// extracted by mini-css-extract-plugin
module.exports = {"container":"status-indicator_container__1Aji2","status-circle":"status-indicator_status-circle__20OIp","text":"status-indicator_text__1TJM6"};